import { useCallback, useEffect } from 'react';
import { enrollInOptimizeExperiment } from './utils';

/**
 *
 * @param object
 *  {
 *      experimentName: Google Optimize experiment ID
 *      defaultVariant: Variant the experience should default to. Defaults to 'A' (or 1)
 *      setVariantEnrollment: Callback with variant value. Should be function
 *                            with stable identity to prevent multiple re-renders
 *  }
 */
export const useOptimizeExperiment = ({
    experimentName,
    defaultVariant,
    setVariantEnrollment,
}: {
    experimentName: string;
    defaultVariant?: string;
    setVariantEnrollment: (variant: string) => any;
}) => {
    const stableEnroll = useCallback(() => {
        if (experimentName) {
            enrollInOptimizeExperiment({
                experimentName,
                defaultVariant,
                setVariantEnrollment,
            });
        }
    }, [experimentName, defaultVariant, setVariantEnrollment]);

    useEffect(() => {
        stableEnroll();
    }, [stableEnroll]);
};
